module.exports = __webpack_public_path__ + "static/img/CC BY-SA.d267381.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/cc/CC BY-SA.png
// module id = 2Uca
// module chunks = 16